import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=b06b0792&scoped=true&"
import script from "./advantage.vue?vue&type=script&lang=js&"
export * from "./advantage.vue?vue&type=script&lang=js&"
import style0 from "./advantage.vue?vue&type=style&index=0&id=b06b0792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b0792",
  null
  
)

export default component.exports